import React from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import SignedInLinks from "./SignedInLinks";
import SignedOutLinks from "./SignedOutLinks";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import MenuIcon from "@material-ui/icons/Menu";
import NewIcon from "@material-ui/icons/FiberNew";
import ExtensionIcon from "@material-ui/icons/Extension";
import DashboardIcon from "@material-ui/icons/Dashboard";
import LensIcon from "@material-ui/icons/Lens";
import GenderIcon from "@material-ui/icons/SupervisorAccount";
import AddGenderIcon from "@material-ui/icons/GroupAdd";
import BackupIcon from "@material-ui/icons/Backup";
import TextFields from "@material-ui/icons/TextFields";
import "./Navbar.css";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import { createMuiTheme } from "@material-ui/core/styles";
import purple from "@material-ui/core/colors/purple";

import { connect } from "react-redux";
import { compose } from "redux";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  leftMargin: {
    marginLeft: "auto",
    marginRight: "16px",
  },
  rightMargin: {
    marginRight: "16px",
  },
  title: {
    flexGrow: 1,
  },
}));

const theme = createMuiTheme({
  palette: {
    primary: purple,
    secondary: {
      main: "#f44336",
    },
  },
});

const AdapterLink = React.forwardRef((props, ref) => (
  <Link innerRef={ref} {...props} />
));

const CollisionLink = React.forwardRef((props, ref) => (
  <Link innerRef={ref} to="/" {...props} />
));

const Navbar = (props) => {
  const { auth, profile } = props;
  const links = auth.uid ? (
    <SignedInLinks profile={auth} />
  ) : (
    <SignedOutLinks />
  );
  const signmenus = auth.uid ? (
    <MenuItem component={AdapterLink} to="/signin" onClick={handleClose}>
      {auth.email}
    </MenuItem>
  ) : (
    <MenuItem component={AdapterLink} to="signout" onClick={handleClose}>
      signout
    </MenuItem>
  );

  const handleMenuClick = () => {
    //alert("click");
    var main_button_helper = document.getElementById("main_button_helper");
    if (main_button_helper != undefined) {
      main_button_helper.click();
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const classes = useStyles();

  const signtoolbar = auth.uid ? (
    <div id="navbar">
      <Toolbar>
        <IconButton
          edge="start"
          onClick={() => handleMenuClick()}
          className={classes.menuButton}
          color="inherit"
          aria-label="Menu"
        >
          <MenuIcon />
        </IconButton>
        {/* <Typography variant="h6" className={classes.title}>
        Dict
      </Typography> */}
        {/* <IconButton
        component={AdapterLink}
        to="/grammar"
        edge="start"
        className={(classes.menuButton, classes.leftMargin)}
        color="inherit"
        aria-label="Menu"
      >
        <TextFields></TextFields>
      </IconButton> */}
        <IconButton
          component={AdapterLink}
          to="/create"
          edge="start"
          className={(classes.menuButton, classes.leftMargin)}
          color="inherit"
          aria-label="Menu"
        >
          <BackupIcon></BackupIcon>
        </IconButton>
        {/* <IconButton component={AdapterLink} to="/" edge="start" className={classes.menuButton} color="inherit" aria-label="Menu">
            <DashboardIcon>
            </DashboardIcon>
          </IconButton> */}
        <IconButton
          component={AdapterLink}
          to="/card"
          edge="start"
          className={classes.menuButton}
          color="inherit"
          aria-label="Menu"
        >
          <ExtensionIcon></ExtensionIcon>
        </IconButton>

        <IconButton
          component={AdapterLink}
          to="/wordcard"
          edge="start"
          className={classes.menuButton}
          color="inherit"
          aria-label="Menu"
        >
          <LensIcon></LensIcon>
        </IconButton>

        <IconButton
          component={AdapterLink}
          to="/addgender"
          edge="start"
          className={classes.menuButton}
          color="inherit"
          aria-label="Menu"
        >
          <AddGenderIcon></AddGenderIcon>
        </IconButton>

        <IconButton
          component={AdapterLink}
          to="/gender"
          edge="start"
          className={classes.menuButton}
          color="inherit"
          aria-label="Menu"
        >
          <GenderIcon></GenderIcon>
        </IconButton>

        {/* <IconButton component={AdapterLink} to="/newverb" edge="start" className={classes.menuButton} color="inherit" aria-label="Menu">
            <BackupIcon>
            </BackupIcon>
          </IconButton> */}

        {/* <IconButton component={AdapterLink} to="/csv" edge="start" className={classes.menuButton} color="inherit" aria-label="Menu">
            <BackupIcon>
            </BackupIcon>
          </IconButton> */}

        <div>
          <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={open}
            onClose={handleClose}
          >
            <MenuItem
              component={AdapterLink}
              to="/newverb"
              onClick={handleClose}
            >
              New verb
            </MenuItem>
            <MenuItem
              component={AdapterLink}
              to="/grammar"
              onClick={handleClose}
            >
              Grammar
            </MenuItem>
            <MenuItem component={AdapterLink} to="/csv" onClick={handleClose}>
              CSV
            </MenuItem>
            <MenuItem
              component={AdapterLink}
              to="/csvGoogle"
              onClick={handleClose}
            >
              CSV G
            </MenuItem>
            <MenuItem
              component={AdapterLink}
              to="/htmlScrape"
              onClick={handleClose}
            >
              htmlScrape
            </MenuItem>
            <MenuItem
              component={AdapterLink}
              to="/Iframe"
              onClick={handleClose}
            >
              Iframe
            </MenuItem>
            <MenuItem component={AdapterLink} to="/" onClick={handleClose}>
              List
            </MenuItem>
            {signmenus}
          </Menu>
        </div>

        {/* <Button color="inherit" component={AdapterLink} to="/">Dashboard</Button>
          <Button color="inherit" component={AdapterLink} to="/create">New Word</Button> */}
      </Toolbar>
    </div>
  ) : (
    <Toolbar></Toolbar>
  );

  return (
    <div className={classes.root}>
      <AppBar position="static">{signtoolbar}</AppBar>
      {/* <Button component={CollisionLink}>new</Button>
      <Button color="primary" component={AdapterLink} to="/">
        Simple case
      </Button> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  // console.log(state);
  let temp_uid = state.firebase.auth.uid;
  if (temp_uid != undefined) {
    localStorage.setItem("user_id", state.firebase.auth.uid);
  }

  //alert("set" + state.firebase.auth.uid);
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};

Navbar.propTypes = {
  classes: PropTypes.object.isRequired,
};
//export default withStyles(useStyles)(Navbar);

export default compose(withStyles(useStyles), connect(mapStateToProps))(Navbar);
